/**
 * 设备配额服务
 * 用于检查和注册设备名额
 */

import { getDeviceId } from '../utils/deviceId';

const QUOTA_API = '/.netlify/functions/quota';
const DEVICE_REGISTERED_KEY = 'enpass_device_registered';

// 从统一模块重新导出，保持向后兼容
export { getDeviceId };

/**
 * 检查设备是否已在本地标记为已注册
 */
export function isDeviceRegisteredLocally(): boolean {
  return localStorage.getItem(DEVICE_REGISTERED_KEY) === 'true';
}

/**
 * 标记设备为已注册
 */
function markDeviceRegistered(): void {
  localStorage.setItem(DEVICE_REGISTERED_KEY, 'true');
}

/**
 * 检查设备配额状态
 */
export async function checkQuota(): Promise<{
  registered: boolean;
  remaining: number;
  quota: number;
}> {
  const deviceId = getDeviceId();
  
  try {
    const res = await fetch(`${QUOTA_API}?deviceId=${deviceId}`);
    if (!res.ok) throw new Error('Failed to check quota');
    return await res.json();
  } catch (error) {
    console.error('[quota] Failed to check:', error);
    // 如果 API 不可用，假设已注册（降级处理）
    return { registered: isDeviceRegisteredLocally(), remaining: 0, quota: 30 };
  }
}

/**
 * 注册设备
 */
export async function registerDevice(): Promise<{
  success: boolean;
  error?: string;
  remaining?: number;
}> {
  const deviceId = getDeviceId();
  
  try {
    const res = await fetch(QUOTA_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ deviceId }),
    });
    
    const data = await res.json();
    
    if (data.success) {
      markDeviceRegistered();
    }
    
    return data;
  } catch (error) {
    console.error('[quota] Failed to register:', error);
    return { success: false, error: '网络错误，请重试' };
  }
}
